import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ApprovalStatuses, DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFile from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentListForProject, getDownloadableLink, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { AttachFile } from "@mui/icons-material";
import { middleTruncate } from "../../helpers/string_helper";
import { ClearIcon } from "@mui/x-date-pickers";
import DoneIcon from "@mui/icons-material/Done";

const useStyles = makeStyles({
  blueIcon: {
    color: '#7b7777',
    // color: '#296ced',
    cursor: 'pointer'
  },
});

const SubmitSecondDeliverable = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  handleStatusChange,
  rowId,
  actionType,
  projectIdForApproval,
  moduleIdforApproval,
  fetchDeliverableDetails,
  status,
  // projectDetails,
  t
}) => {

  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [deliverableObject, setDeliverableObject] = useState({
    name: selectedRow?.deliverable.name ?? "",
    startDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate ? selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate : selectedRow?.deliverable.startDate,
    endDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate? selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate : selectedRow?.deliverable.endDate,
    description: selectedRow?.description ?? ""
  });
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [businessModelLoading, setBusinessModelLoading] = useState(false);
  const [customerSegmentLoading, setCustomerSegmentLoading] = useState(false);
  const [propositionModelLoading, setPropositionModelLoading] = useState(false);
  const [virtualPersonalityLoading, setVirtualPersonalityLoading] = useState(false);
  const [marketSizeFileLoading, setMarketSizeLoading] = useState(false);
  const [exerciseFileLoading, setExerciseLoading] = useState(false);
  const [deletingFileType, setDeletingFileType] = useState('');
  const [businessModelFiles, setBusinessModelFiles] = useState([]);
  const [customerSegmentFiles, setCustomerSegmentFiles] = useState([]);
  const [propositionModelFiles, setPropositionModelFiles] = useState([]);
  const [virtualPersonalityFiles, setVirtualPersonalityFiles] = useState([]);
  const [MarketSizeFiles, setMarketSizeFiles] = useState([]);
  const [exerciseFiles, setExerciseFiles] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [approvedButtonLoading, setApprovedButtonLoading] = useState(false);
  const [rejectButtonLoading, setRejectButtonLoading] = useState(false);

  const deliverableValidation = Yup.object().shape({
    description: Yup.string()
      .max(2000, t("Description can not be greater than 2000 characters"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter Description")),
    // attachmentId: Yup.number().required(t('Select an attachment')),
    // businessModel: Yup.string()
    //   .max(250, t("Too Long!"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .nullable(),
    // customerSegment: Yup.string()
    //   .max(250, t("Too Long!"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .nullable(),
    //   // .required(t("Please enter Customer Segment Analysis")),
    // propositionModel: Yup.string()
    //   .max(250, t("Too Long!"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .nullable(),
    //   // .required(t("Please enter Value Proposition Model")),
    // customerPersonality: Yup.string()
    //   .max(250, t("Too Long!"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .nullable(),
    //   // .required(t("Please enter Virtual Customer Personality")),
    // marketSize: Yup.string()
    //   .max(250, t("Too Long!"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .nullable(),
    //   // .required(t("Please enter market size")),
    // exercise: Yup.string()
    //   .max(250, t("Too Long!"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .nullable(),
    //   // .required(t("Please enter exercises to verify assumptions")),
    businessModelAttachmentId: Yup.array().of(Yup.number())
      .min(1, t('Select at least one Business Model document')),
    customerSegmentAttachmentId: Yup.array().of(Yup.number())
      .min(1, t('Select at least one Customer Segment Analysis document')),
    propositionModelAttachmentId: Yup.array().of(Yup.number())
      .min(1, t('Select at least one Proposition Model document')),
    customerPersonalityAttachmentId: Yup.array().of(Yup.number())
      .min(1, t('Select at least one Virtual Customer Personality document')),
    marketSizeAttachmentId: Yup.array().of(Yup.number())
      .min(1, t('Select at least one Market Size document')),
    exerciseAttachmentId: Yup.array().of(Yup.number())
      .min(1, t('Select at least one Exercises to verify Assumptions document')),
  });

  const formik = useFormik({
    initialValues: {
      businessModel: selectedRow?.businessModel ?? "",
      customerSegment: selectedRow?.customerSegmentAnalysis ?? "",
      propositionModel: selectedRow?.valuePropositionModel ?? "",
      customerPersonality: selectedRow?.virtualCustomerPersonality
        ?? "",
      marketSize: selectedRow?.marketSize ?? "",
      exercise: selectedRow?.exercisesVariousAssumption
        ?? "",
      businessModelAttachmentId: "",
      customerSegmentAttachmentId: "",
      propositionModelAttachmentId: "",
      customerPersonalityAttachmentId: "",
      marketSizeAttachmentId: "",
      exerciseAttachmentId: "",
      ...deliverableObject,
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    // onSubmit: (values) => {
    //   handleUpdate();
    // }
  });

  useEffect(() => {
    if (selectedRow && action !== Action.EDIT) {
      getDocumentList()
      if (
        ![DeliverableStatus.DRAFT, DeliverableStatus.REJECTED].includes(
          selectedRow.currentStatus
        ) ||
        isDisabled || action === Action.VIEW || action === Action.APPROVE
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  const handleFileUpload = async (key, files) => {
    const loaders = {
      'Business Model': setBusinessModelLoading,
      'Customer Segment Analysis': setCustomerSegmentLoading,
      'Value Proposition Model': setPropositionModelLoading,
      'Virtual Customer Personality': setVirtualPersonalityLoading,
      'Market Size': setMarketSizeLoading,
      'Exercises to verify Assumptions': setExerciseLoading,
    };

    const formikFields = {
      'Business Model': 'businessModelAttachmentId',
      'Customer Segment Analysis': 'customerSegmentAttachmentId',
      'Value Proposition Model': 'propositionModelAttachmentId',
      'Virtual Customer Personality': 'customerPersonalityAttachmentId',
      'Market Size': 'marketSizeAttachmentId',
      'Exercises to verify Assumptions': 'exerciseAttachmentId',
    };
    const validFiles = Array.from(files).filter((file) => {
      const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;
      if (!AcceptFileType.includes(fileExtension)) {
        toast.error(`"${file.name}" has invalid file type`);
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        toast.error("Please upload file size less than 10 MB");
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    const setLoader = loaders[key];
    setLoader(true);

    try {
      const formData = new FormData();
      validFiles.forEach(file => {
        formData.append('files', file);
      });

      formData.append('moduleId', selectedRow.id);
      formData.append('module', DocumentModule.PROJECT_DELIVERABLE);
      formData.append('projectId', selectedRow.projectId);
      formData.append('documentType', key);

      const result = (await uploadFile(formData)).data.data;

      // formik.setFieldValue(formikFields[key], result.map(file => file.id));
      formik.setFieldValue(formikFields[key], [result.id]);
      formik.setFieldTouched(formikFields[key], true);

      setTrigger(new Date());
      getDocumentList();
    } catch (error) {
      toast.error(error.message || 'Error uploading files');
    } finally {
      setLoader(false);
    }
  };

  const handleLinkDownload = async (documentId) => {
    try {
      const result = await getDownloadableLink(documentId);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
        window.open(result.data.data, '_blank');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const getDocumentList = async () => {
    try {
      // Set all loading states to true
      setBusinessModelLoading(true);
      setCustomerSegmentLoading(true);
      setPropositionModelLoading(true);
      setVirtualPersonalityLoading(true);
      setMarketSizeLoading(true);
      setExerciseLoading(true);

      const params = {
        projectId: selectedRow.projectId,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.PROJECT_DELIVERABLE,
        moduleId: selectedRow.id
      };

      const documentData = await documentListForProject(params);
      const documentDataList = documentData.data.data;

      const filesByType = {
        'Business Model': [],
        'Customer Segment Analysis': [],
        'Value Proposition Model': [],
        'Virtual Customer Personality': [],
        'Market Size': [],
        'Exercises to verify Assumptions': [],
      };

      documentDataList.forEach(doc => {
        const type = doc.documentType.name;
        if (filesByType[type]) {
          filesByType[type].push(doc);
        }
      });

      setBusinessModelFiles(filesByType['Business Model']);
      formik.setFieldValue('businessModelAttachmentId', filesByType['Business Model'].map(f => f.id));

      setCustomerSegmentFiles(filesByType['Customer Segment Analysis']);
      formik.setFieldValue('customerSegmentAttachmentId', filesByType['Customer Segment Analysis'].map(f => f.id));

      setPropositionModelFiles(filesByType['Value Proposition Model']);
      formik.setFieldValue('propositionModelAttachmentId', filesByType['Value Proposition Model'].map(f => f.id));

      setVirtualPersonalityFiles(filesByType['Virtual Customer Personality']);
      formik.setFieldValue('customerPersonalityAttachmentId', filesByType['Virtual Customer Personality'].map(f => f.id));

      setMarketSizeFiles(filesByType['Market Size']);
      formik.setFieldValue('marketSizeAttachmentId', filesByType['Market Size'].map(f => f.id));

      setExerciseFiles(filesByType['Exercises to verify Assumptions']);
      formik.setFieldValue('exerciseAttachmentId', filesByType['Exercises to verify Assumptions'].map(f => f.id));

    } catch (err) {
      console.error(err);
    } finally {
      setBusinessModelLoading(false);
      setCustomerSegmentLoading(false);
      setPropositionModelLoading(false);
      setVirtualPersonalityLoading(false);
      setMarketSizeLoading(false);
      setExerciseLoading(false);
    }
  };

  const handelDeleteAttachment = async () => {
    const loaderMap = {
      'Business Model': setBusinessModelLoading,
      'Customer Segment Analysis': setCustomerSegmentLoading,
      'Value Proposition Model': setPropositionModelLoading,
      'Virtual Customer Personality': setVirtualPersonalityLoading,
      'Market Size': setMarketSizeLoading,
      'Exercises to verify Assumptions': setExerciseLoading
    };

    try {
      setIsOpenSweetAlert(false);
      const loaderSetter = loaderMap[deletingFileType];
      loaderSetter?.(true);

      await deleteDocument(documentId);
      toast.success('Document deleted successfully');

      let updatedFiles = [];
      switch (deletingFileType) {
        case 'Business Model':
          updatedFiles = businessModelFiles.filter(file => file.id !== documentId);
          setBusinessModelFiles(updatedFiles);
          formik.setFieldValue('businessModelAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('businessModelAttachmentId', true);
          break;
        case 'Customer Segment Analysis':
          updatedFiles = customerSegmentFiles.filter(file => file.id !== documentId);
          setCustomerSegmentFiles(updatedFiles);
          formik.setFieldValue('customerSegmentAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('customerSegmentAttachmentId', true);
          break;
        case 'Value Proposition Model':
          updatedFiles = propositionModelFiles.filter(file => file.id !== documentId);
          setPropositionModelFiles(updatedFiles);
          formik.setFieldValue('propositionModelAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('propositionModelAttachmentId', true);
          break;
        case 'Virtual Customer Personality':
          updatedFiles = virtualPersonalityFiles.filter(file => file.id !== documentId);
          setVirtualPersonalityFiles(updatedFiles);
          formik.setFieldValue('customerPersonalityAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('customerPersonalityAttachmentId', true);
          break;
        case 'Market Size':
          updatedFiles = MarketSizeFiles.filter(file => file.id !== documentId);
          setMarketSizeFiles(updatedFiles);
          formik.setFieldValue('marketSizeAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('marketSizeAttachmentId', true);
          break;
        case 'Exercises to verify Assumptions':
          updatedFiles = exerciseFiles.filter(file => file.id !== documentId);
          setExerciseFiles(updatedFiles);
          formik.setFieldValue('exerciseAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('exerciseAttachmentId', true);
          break;
        default:
          break;
      }

      await formik.validateForm();
      setDocumentId(null);
      setDeletingFileType('');
      loaderSetter?.(false);
    } catch (err) {
      loaderMap[deletingFileType]?.(false);
      setDocumentId(null);
      setDeletingFileType('');
      toast.error(err.message || 'Failed to delete document');
    }
  };

  const hasAtLeastOneFile =
    businessModelFiles.length ||
    customerSegmentFiles.length ||
    propositionModelFiles.length ||
    virtualPersonalityFiles.length ||
    MarketSizeFiles.length ||
    exerciseFiles.length;

  const deliverableSubmit = async () => {
    try {
      const isValid = await formik.validateForm();

      if (Object.keys(isValid).length !== 0) {
        formik.setTouched({
          // businessModel: true,
          // customerSegment: true,
          // propositionModel: true,
          // customerPersonality: true,
          // marketSize: true,
          // exercise: true,
          businessModelAttachmentId: true,
          customerSegmentAttachmentId: true,
          propositionModelAttachmentId: true,
          customerPersonalityAttachmentId: true,
          marketSizeAttachmentId: true,
          exerciseAttachmentId: true
        });
        return toast.error("Please fix the validation errors.");
      }

      setIsLoading(true);

      const normalizeToArray = (value) => {
        if (Array.isArray(value)) return value;
        if (value === null || value === undefined) return [];
        return [value];
      };

      const payload = {
        ...formik.values,
        status: ProjectDeliverableStatus.APPROVED,
        projectId: parseInt(selectedRow.projectId),
        deliverableId: parseInt(selectedRow.deliverable.id),

        businessModelAttachmentId: normalizeToArray(formik.values.businessModelAttachmentId),
        customerSegmentAttachmentId: normalizeToArray(formik.values.customerSegmentAttachmentId),
        propositionModelAttachmentId: normalizeToArray(formik.values.propositionModelAttachmentId),
        customerPersonalityAttachmentId: normalizeToArray(formik.values.customerPersonalityAttachmentId),
        marketSizeAttachmentId: normalizeToArray(formik.values.marketSizeAttachmentId),
        exerciseAttachmentId: normalizeToArray(formik.values.exerciseAttachmentId),
      };

      const res = await updateDeliverableStatus(payload);

      if (res.statusCode === 200) {
        toast.success(res.data.message);
        refresh();
      } else {
        toast.error(res.message);
      }

      handleClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        className="projectListDrawer"
        PaperProps={{
          sx: { width: "580px" },
        }}
      >
        <form className="editMilestoneDrawer p-3">
          <h5>{t("Deliverable")}</h5>
          <CloseIcon className="crossIcon" onClick={handleClose} />
          <div className="innerTbContent">
            <div className="row">
              {/* Name */}
              <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={t("Name")}
                  name="name"
                  value={formik.values.name}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                {formik.touched.name && formik.errors.name && (
                  <span className="text-danger">{formik.errors.name}</span>
                )}
              </div>

              {/* Start Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.startDate && (
                      <DatePicker
                        label={t("Start Date") + " *"}
                        name="startDate"
                        format="MM/DD/YYYY"
                        value={
                          formik?.values?.startDate?.toString().trim()
                            ? dayjs(formik.values.startDate)
                            : null
                        }
                        on
                        slotProps={{
                          field: {
                            clearable: true, onBlur: (_) => {
                              if (!formik.touched?.startDate) {
                                formik.setFieldTouched("startDate", true, false);
                              }
                            }
                          },
                          onClear: () => {
                            formik.setFieldValue("startDate", '');
                          },
                        }}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "startDate",
                            e ? dayjs(e).format("YYYY-MM-DD") : ''
                          );
                          if (!formik.touched?.startDate) {
                            formik.setFieldTouched("startDate", true, false);
                          }
                        }}
                        readOnly={
                          isLoading || disabled

                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider>
                {formik.touched.startDate &&
                  formik.errors.startDate && (
                    <span className="text-danger">
                      {formik.errors.startDate}
                    </span>
                  )}
              </div>

              {/* End Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.endDate && (
                      <DatePicker
                        label={t("End Date") + " *"}
                        name="endDate"
                        format="MM/DD/YYYY"
                        value={
                          formik?.values?.endDate?.toString().trim()
                            ? dayjs(formik.values.endDate)
                            : null
                        }
                        slotProps={{
                          field: {
                            clearable: true, onBlur: (_) => {
                              if (!formik.touched?.endDate) {
                                formik.setFieldTouched("endDate", true, false);
                              }
                            }
                          },
                          onClear: () => {
                            formik.setFieldValue("endDate", '');
                          },
                        }}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "endDate",
                            e ? dayjs(e).format("YYYY-MM-DD") : ''
                          );
                          if (!formik.touched?.endDate) {
                            formik.setFieldTouched("endDate", true, false);
                          }
                        }}
                        readOnly={
                          isLoading || disabled
                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider>
                {formik.touched.endDate &&
                  formik.errors.endDate && (
                    <span className="text-danger">
                      {formik.errors.endDate}
                    </span>
                  )}
              </div>

              {/* Description */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.description !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    fullWidth
                    className="form-control"
                    id="deliverable-title-input"
                    label={t("Description")}
                    name="description"
                    value={formik.values.description}
                    // inputProps={{
                    //   readOnly: isLoading || disabled,
                    // }}
                    disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    required
                    rows={2}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <span className="text-danger">{formik.errors.description}</span>
                  )}
                </>
                {/* : <></>)} */}
              </div>

              {/* Business Model */}
              {/* <div className="col-sm-12 mb-3">
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="businessModel"
                    label={t("Business Model")}
                    name="businessModel"
                    value={formik.values.businessModel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                  />
                  {formik.touched.businessModel && formik.errors.businessModel && (
                    <span className="text-danger">{formik.errors.businessModel}</span>
                  )}
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-0">
                  <h5 className="mx-2 mb-1" style={{fontSize:'15px',fontWeight:'500', color:'#2F333C'}}>{t("Business Model")}</h5>
                  {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW
                  &&(
                    <div className="uploaded_file">
                      <div key={trigger} className="p-3 d-flex align-items-center position-relative">
                        <AttachFile
                          className="attachment_button"
                          style={{ cursor: 'pointer' }}
                        />
                        <span className="mx-2">{t("Attach Document")}
                        {businessModelFiles.length === 0 && (
                          <span style={{ color: 'red' }}>*</span>
                        )}
                        </span>
                        <input
                          key={trigger}
                          type="file"
                          multiple
                          accept={AcceptFileType.toString()}
                          name="documents"
                          onChange={(e) => handleFileUpload('Business Model', e.target.files)}
                          onBlur={() => {
                            if (!formik.touched?.businessModelAttachmentId) {
                              formik.setFieldTouched("businessModelAttachmentId", true, false);
                            }
                          }}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* {!businessModelLoading && businessModelFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Business Model Document")}:</h5>
                  )} */}
                </div>

                <div className="mx-3">
                  {formik.touched.businessModelAttachmentId && formik.errors.businessModelAttachmentId && (
                    <span className="text-danger">{formik.errors.businessModelAttachmentId}</span>
                  )}
                </div>

                <div className="mb-3">
                  {businessModelLoading && <Loader />}
                  {!businessModelLoading && businessModelFiles.length > 0 && businessModelFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between mx-2' key={key}>
                      <span className='fw-semibold text-truncate' style={{color:'#7b7777'}} title={file.name}>
                        {middleTruncate(file.name)}
                      </span>
                      <div className="actions d-flex align-items-center gap-2">
                        <RemoveRedEyeOutlinedIcon
                          style={{color:'#7b7777'}}
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                        <DownloadIcon className={classes.blueIcon}  onClick={() => {
                          handleLinkDownload(file.id)
                        }} />
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW &&(
                          <DeleteOutlineOutlinedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDocumentId(file.id);
                              setDeletingFileType('Business Model');
                              setIsOpenSweetAlert(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {selectedRow?.deliverableRejectComments?.[0]?.businessModalComment && (
                    <div className="mt-2 mb-2">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Business Model Comment")}
                        name="businessModalComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.businessModalComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </div>
              </>

              {/* Customer Segment Analysis */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="customerSegment"
                    label={t("Customer Segment Analysis")}
                    name="customerSegment"
                    value={formik.values.customerSegment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                  />
                  {formik.touched.customerSegment && formik.errors.customerSegment && (
                    <span className="text-danger">{formik.errors.customerSegment}</span>
                  )}
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-0">
                  <h5 className="mx-2 mb-1" style={{fontSize:'15px',fontWeight:'500', color:'#2F333C'}}>{t("Customer Segment Analysis")}</h5>
                  {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW &&(
                    <div className="uploaded_file">
                      <div key={trigger} className="p-3 d-flex align-items-center position-relative">
                        <AttachFile
                          className="attachment_button"
                          style={{ cursor: 'pointer' }}
                        />
                        <span className="mx-2">{t("Attach Document")}
                        {customerSegmentFiles.length === 0 && (
                          <span style={{ color: 'red' }}>*</span>
                        )}
                        </span>
                        <input
                          key={trigger}
                          type="file"
                          multiple
                          accept={AcceptFileType.toString()}
                          name="documents"
                          onChange={(e) => handleFileUpload('Customer Segment Analysis', e.target.files)}
                          onBlur={() => {
                            if (!formik.touched?.customerSegmentAttachmentId) {
                              formik.setFieldTouched("customerSegmentAttachmentId", true, false);
                            }
                          }}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* {!customerSegmentLoading && customerSegmentFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Customer Segment Analysis Document")}:</h5>
                  )} */}
                </div>

                <div className="mx-3">
                  {formik.touched.customerSegmentAttachmentId && formik.errors.customerSegmentAttachmentId && (
                    <span className="text-danger">{formik.errors.customerSegmentAttachmentId}</span>
                  )}
                </div>

                <div className="mb-3">
                  {customerSegmentLoading && <Loader />}
                  {!customerSegmentLoading && customerSegmentFiles.length > 0 && customerSegmentFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between mx-2' key={key}>
                      <span className='fw-semibold text-truncate' style={{color:'#7b7777'}} title={file.name}>
                        {middleTruncate(file.name)}
                      </span>
                      <div className="actions d-flex align-items-center gap-2">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                        <DownloadIcon className={classes.blueIcon} onClick={() => {
                          handleLinkDownload(file.id)
                        }} />
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                          <DeleteOutlineOutlinedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDocumentId(file.id);
                              setDeletingFileType('Customer Segment Analysis');
                              setIsOpenSweetAlert(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {selectedRow?.deliverableRejectComments?.[0]?.customerSegmentAnalysisComment && (
                    <div className="mt-2 mb-2">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Customer Segment Analysis Comment")}
                        name="customerSegmentAnalysisComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.customerSegmentAnalysisComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </div>
              </>


              {/* Value Proposition Model */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="propositionModel"
                    label={t("Value Proposition Model")}
                    name="propositionModel"
                    value={formik.values.propositionModel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                  />
                  {formik.touched.propositionModel && formik.errors.propositionModel && (
                    <span className="text-danger">{formik.errors.propositionModel}</span>
                  )}
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-0">
                  <h5 className="mx-2 mb-1" style={{fontSize:'15px',fontWeight:'500', color:'#2F333C'}}>{t("Value Proposition Model")}</h5>
                  {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                    <div className="uploaded_file">
                      <div key={trigger} className="p-3 d-flex align-items-center position-relative">
                        <AttachFile
                          className="attachment_button"
                          style={{ cursor: 'pointer' }}
                        />
                        <span className="mx-2">{t("Attach Document")}
                        {propositionModelFiles.length === 0 && (
                          <span style={{ color: 'red' }}>*</span>
                        )}
                        </span>
                        <input
                          key={trigger}
                          type="file"
                          multiple
                          accept={AcceptFileType.toString()}
                          name="documents"
                          onChange={(e) => handleFileUpload('Value Proposition Model', e.target.files)}
                          onBlur={() => {
                            if (!formik.touched?.propositionModelAttachmentId) {
                              formik.setFieldTouched("propositionModelAttachmentId", true, false);
                            }
                          }}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* {!propositionModelLoading && propositionModelFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Value Proposition Model Document")}:</h5>
                  )} */}
                </div>

                <div className="mx-3">
                  {formik.touched.propositionModelAttachmentId && formik.errors.propositionModelAttachmentId && (
                    <span className="text-danger">{formik.errors.propositionModelAttachmentId}</span>
                  )}
                </div>

                <div className="mb-3">
                  {propositionModelLoading && <Loader />}
                  {!propositionModelLoading && propositionModelFiles.length > 0 && propositionModelFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between mx-2' key={key}>
                      <span className='fw-semibold text-truncate' style={{color:'#7b7777'}} title={file.name}>
                        {middleTruncate(file.name)}</span>
                      <div className="actions d-flex align-items-center gap-2">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                        <DownloadIcon className={classes.blueIcon} onClick={() => {
                          handleLinkDownload(file.id)
                        }} />
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW &&( 
                          <DeleteOutlineOutlinedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDocumentId(file.id);
                              setDeletingFileType('Value Proposition Model');
                              setIsOpenSweetAlert(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {selectedRow?.deliverableRejectComments?.[0]?.valuePropositionModelComment && (
                    <div className="mt-2 mb-2">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Value Proposition Model Comment")}
                        name="valuePropositionModelComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.valuePropositionModelComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </div>
              </>


              {/* Virtual Customer Personality */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="customerPersonality"
                    label={t("Virtual Customer Personality")}
                    name="customerPersonality"
                    value={formik.values.customerPersonality}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                  />
                  {formik.touched.customerPersonality && formik.errors.customerPersonality && (
                    <span className="text-danger">{formik.errors.customerPersonality}</span>
                  )}
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-0">
                  <h5 className="mx-2 mb-1" style={{fontSize:'15px',fontWeight:'500', color:'#2F333C'}}>{t("Virtual Customer Personality")}</h5>
                  {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                    <div className="uploaded_file">
                      <div key={trigger} className="p-3 d-flex align-items-center position-relative">
                        <AttachFile
                          className="attachment_button"
                          style={{ cursor: 'pointer' }}
                        />
                        <span className="mx-2">{t("Attach Document")}
                        {virtualPersonalityFiles.length === 0 && (
                          <span style={{ color: 'red' }}>*</span>
                        )}
                        </span>
                        <input
                          key={trigger}
                          type="file"
                          multiple
                          accept={AcceptFileType.toString()}
                          name="documents"
                          onChange={(e) => handleFileUpload('Virtual Customer Personality', e.target.files)}
                          onBlur={() => {
                            if (!formik.touched?.customerPersonalityAttachmentId) {
                              formik.setFieldTouched("customerPersonalityAttachmentId", true, false);
                            }
                          }}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* {!virtualPersonalityLoading && virtualPersonalityFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Virtual Customer Personality Document")}:</h5>
                  )} */}
                </div>

                <div className="mx-3">
                  {formik.touched.customerPersonalityAttachmentId && formik.errors.customerPersonalityAttachmentId && (
                    <span className="text-danger">{formik.errors.customerPersonalityAttachmentId}</span>
                  )}
                </div>

                <div className="mb-3">
                  {virtualPersonalityLoading && <Loader />}
                  {!virtualPersonalityLoading && virtualPersonalityFiles.length > 0 && virtualPersonalityFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between mx-2' key={key}>
                      <span className='fw-semibold text-truncate' style={{color:'#7b7777'}} title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions d-flex align-items-center gap-2">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                        <DownloadIcon className={classes.blueIcon} onClick={() => {
                          handleLinkDownload(file.id)
                        }} />
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                          <DeleteOutlineOutlinedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDocumentId(file.id);
                              setDeletingFileType('Virtual Customer Personality');
                              setIsOpenSweetAlert(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {selectedRow?.deliverableRejectComments?.[0]?.virtualCustomerPersonalityComment && (
                    <div className="mt-2 mb-2">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Virtual Customer Personality Comment")}
                        name="virtualCustomerPersonalityComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.virtualCustomerPersonalityComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </div>
              </>


              {/* Market Size */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="marketSize"
                    label={t("Market Size")}
                    name="marketSize"
                    value={formik.values.marketSize}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                  />
                  {formik.touched.marketSize && formik.errors.marketSize && (
                    <span className="text-danger">{formik.errors.marketSize}</span>
                  )}
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-0">
                  <h5 className="mx-2 mb-1" style={{fontSize:'15px',fontWeight:'500', color:'#2B2F3E'}}>{t("Market Size")}</h5>
                  {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW &&(
                    <div className="uploaded_file">
                      <div key={trigger} className="p-3 d-flex align-items-center position-relative">
                        <AttachFile
                          className="attachment_button"
                          style={{ cursor: 'pointer' }}
                        />
                        <span className="mx-2">{t("Attach Document")}
                          {MarketSizeFiles.length === 0 && (
                            <span style={{ color: 'red' }}>*</span>
                          )}
                        </span>
                        <input
                          key={trigger}
                          type="file"
                          multiple
                          accept={AcceptFileType.toString()}
                          name="documents"
                          onChange={(e) => handleFileUpload('Market Size', e.target.files)}
                          onBlur={() => {
                            if (!formik.touched?.marketSizeAttachmentId) {
                              formik.setFieldTouched("marketSizeAttachmentId", true, false);
                            }
                          }}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* {!marketSizeFileLoading && MarketSizeFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Market Size Document")}:</h5>
                  )} */}
                </div>

                <div className="mx-3">
                  {formik.touched.marketSizeAttachmentId && formik.errors.marketSizeAttachmentId && (
                    <span className="text-danger">{formik.errors.marketSizeAttachmentId}</span>
                  )}
                </div>

                <div className="mb-3">
                  {marketSizeFileLoading && <Loader />}
                  {!marketSizeFileLoading && MarketSizeFiles.length > 0 && MarketSizeFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between mx-2' key={key}>
                      <span className='fw-semibold text-truncate' style={{color:'#7b7777'}} title={file.name}>
                        {middleTruncate(file.name)}
                      </span>
                      <div className="actions d-flex align-items-center gap-2">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                        <DownloadIcon className={classes.blueIcon} onClick={() => {
                          handleLinkDownload(file.id)
                        }} />
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                          <DeleteOutlineOutlinedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDocumentId(file.id);
                              setDeletingFileType('Market Size');
                              setIsOpenSweetAlert(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {selectedRow?.deliverableRejectComments?.[0]?.marketSizeComment && (
                    <div className="mt-2 mb-2">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Market Size Comment")}
                        name="marketSizeComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.marketSizeComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </div>
              </>


              {/* Exercises to verify assumptions */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="exercise"
                    label={t("Exercises to verify Assumptions")}
                    name="exercise"
                    value={formik.values.exercise}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                  />
                  {formik.touched.exercise && formik.errors.exercise && (
                    <span className="text-danger">{formik.errors.exercise}</span>
                  )}
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-0">
                  <h5 className="mx-2 mb-1" style={{fontSize:'16px',fontWeight:'500', color:'#2B2F3E'}}>{t("Exercises to verify Assumptions")}</h5>
                  {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                    <div className="uploaded_file">
                      <div key={trigger} className="p-3 mx-2 d-flex align-items-center position-relative">
                        <AttachFile
                          className="attachment_button"
                          style={{ cursor: 'pointer' }}
                        />
                        <span className="mx-2">{t("Attach Document")}
                          {exerciseFiles.length === 0 && (
                            <span style={{ color: 'red' }}>*</span>
                          )}
                        </span>
                        <input
                          key={trigger}
                          type="file"
                          multiple
                          accept={AcceptFileType.toString()}
                          name="documents"
                          onChange={(e) => handleFileUpload('Exercises to verify Assumptions', e.target.files)}
                          onBlur={() => {
                            if (!formik.touched?.exerciseAttachmentId) {
                              formik.setFieldTouched("exerciseAttachmentId", true, false);
                            }
                          }}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* {!exerciseFileLoading && exerciseFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Exercises to verify Assumptions Document")}:</h5>
                  )} */}
                </div>

                <div className="mx-3">
                  {formik.touched.exerciseAttachmentId && formik.errors.exerciseAttachmentId && (
                    <span className="text-danger">{formik.errors.exerciseAttachmentId}</span>
                  )}
                </div>

                <div className="mb-3">
                  {exerciseFileLoading && <Loader />}
                  {!exerciseFileLoading && exerciseFiles.length > 0 && exerciseFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between mx-2' key={key}>
                      <span className='fw-semibold text-truncate' style={{color:'#7b7777'}} title={file.name}>
                        {middleTruncate(file.name)}
                      </span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                        <DownloadIcon className={classes.blueIcon} onClick={() => {
                          handleLinkDownload(file.id)
                        }} />
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW &&(
                          <DeleteOutlineOutlinedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDocumentId(file.id);
                              setDeletingFileType('Exercises to verify Assumptions');
                              setIsOpenSweetAlert(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  {selectedRow?.deliverableRejectComments?.[0]?.exercisesVariousAssumptionComment && (
                    <div className="mt-2 mb-2">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Exercises to verify Assumptions Comment")}
                        name="exercisesVariousAssumptionComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.exercisesVariousAssumptionComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </div>
              </>
            </div>
          </div>
          {action === Action.SUBMIT && [ProjectDeliverableStatus.ONGOING, ProjectDeliverableStatus.REJECTED, ProjectDeliverableStatus.DELAYED].includes(
            selectedRow.currentStatus
          ) && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={deliverableSubmit}
                  disabled={isLoading || !formik.isValid || !hasAtLeastOneFile}
                  className="btn addNew_ProjectBtn"
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Submit")}
                </Button>
              </div>
            )}

          {action === Action.APPROVE 
              && (
                  <div className="plsubmitButton justify-content-center mt-4">
                    <Button
                      onClick={async () => {
                        setButtonLoading(true);
                        await handleStatusChange(
                        moduleIdforApproval,
                        actionType,
                        projectIdForApproval,
                        ApprovalStatuses.APPROVED,
                        rowId
                      )
                      setButtonLoading(false)
                      }
                    }
                      className="btn addNew_ProjectBtn"
                    >
                      {buttonLoading && (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-1"
                        />
                      )}
                      {t("Approve")}
                    </Button>
                  </div>
                )}

        {action === Action.APPROVE_REJECT_SHOW 
          && 
            (
              <div
                className="proSubmissionActions"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: "7px",
                  paddingTop: "6px",
                }}
              >
                  {status ? (
                    status === ProjectDeliverableStatus.APPROVED ? (
                      <Button disabled variant="contained" className="approveBtn" style={{ color: "black", border: "none", textTransform: "none" }}>
                        <DoneIcon className="me-1" />
                        {t("Approved")}
                      </Button>
                    ) : status === ProjectDeliverableStatus.REJECTED ? (
                      <Button disabled variant="contained" color="error" className="rejectBtn" style={{ marginRight: "10px", color: "black", textTransform: "none" }}>
                        <ClearIcon className="me-1" />
                        {t("Rejected")}
                      </Button>
                    ) : (
                      <>
                        <Button
                          disableElevation
                          variant="contained"
                          className="approveBtn"
                          style={{
                            backgroundColor: "#90EE90",
                            color: "black",
                            border: "none",
                            textTransform: "none",
                          }}
                          onClick={async () => {
                            setApprovedButtonLoading(true);
                            await handleStatusChange(
                              moduleIdforApproval,
                              actionType,
                              projectIdForApproval,
                              ApprovalStatuses.APPROVED,
                              rowId
                            );
                            setApprovedButtonLoading(false);
                          }}
                        >
                          {approvedButtonLoading && (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-1"
                            />
                          )}
                          <DoneIcon className="me-1" />
                          {t("Approve")}
                        </Button>

                        <Button
                          disableElevation
                          variant="contained"
                          color="error"
                          className="rejectBtn"
                          onClick={async () => {
                            setRejectButtonLoading(true);
                            await fetchDeliverableDetails(
                              moduleIdforApproval,
                              projectIdForApproval,
                              Action.SUBMIT,
                              {
                                moduleId: moduleIdforApproval,
                                actionType: "projectDeliverable",
                                projectId: projectIdForApproval,
                                approvalId: rowId,
                              }
                            );
                            setRejectButtonLoading(false);
                          }}
                          style={{
                            marginRight: "10px",
                            backgroundColor: "#FFC0CB",
                            color: "black",
                            textTransform: "none",
                          }}
                        >
                          {rejectButtonLoading && (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-1"
                            />
                          )}
                          <ClearIcon className="me-1" />
                          {t("Reject")}
                        </Button>
                      </>
                    )
                  ) : null}     
              </div>
            )
        }

        </form>
      </Drawer>
      {isOpenSweetAlert && (
        <SweetAlert
          title="Are you sure want to delete this document?"
          warning
          showCancel
          confirmButtonText="Yes, delete it!"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => handelDeleteAttachment()}
          onCancel={() => {
            setIsOpenSweetAlert(false)
          }}>
        </SweetAlert>
      )}

      {modal && (
        <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
      )}
    </>
  );
};

export default withTranslation()(SubmitSecondDeliverable);
